import _ from 'lodash';
// import through webpack for now, should move to dist and import async if they get too big
import en_US from '../translations/en-US.json';
import en_US_monitoring from '../translations/en-US-monitoring.json';
import en_US_analytics from '../translations/en-US-analytics.json';
import en_US_admin from '../translations/en-US-admin.json';

const UNIVERSAL = 'universal';
const MONITORING = 'monitoring';
const ANALYTICS = 'analytics';
const ADMIN = 'admin';

const languageMap = {
    'en': {
        [UNIVERSAL]: en_US,
        [MONITORING]: en_US_monitoring,
        [ANALYTICS]: en_US_analytics,
        [ADMIN]: en_US_admin,
    },
    'en-US': {
        [UNIVERSAL]: en_US,
        [MONITORING]: en_US_monitoring,
        [ANALYTICS]: en_US_analytics,
        [ADMIN]: en_US_admin,
    },
    'es': {
        [UNIVERSAL]: [],
    },
    'fr': {
        [UNIVERSAL]: [],
    },
    'uk': {
        [UNIVERSAL]: [],
    },
}
let translations;

export default class TranslationService {
    constructor() {
        if (!translations) {
          translations = languageMap.en;
        }
        // TODO: After all translations are done switch to this logic
        // if (!translations) {
        //     let language = getFirstBrowserLanguage();
        //     this.translations = languageMap[language] || languageMap[language.substring(0, 2)] || languageMap.en;
        //     translations = this.translations;
        // }
        this.translations = translations;
    }

    /**
     * Function to translate a user message to the browser default language.
     *
     * @param {string} key - The message key, a camel case string optionally split into [file key].[message key]
     *                       If under 3 words the actual message converted to camel case or a short description if longer.
     * @param {object} args - a map of key in the message to value that should be put in the final string
     *
     * @return {string} a UI ready localized string
     */
    translate(key, args) {
        let keyBreakdown = key.split('.');
        let messageTemplate = this.translations[UNIVERSAL][key];
        if (keyBreakdown.length > 1) {
            if (keyBreakdown[0] === 'monitoring') {
                messageTemplate = this.translations[keyBreakdown[0]][keyBreakdown[1]];
            }
        }
        if (messageTemplate) {
            // let interpolator = _.template(messageTemplate, { interpolate: /{{([\s\S]+?)}}/g });
            // return interpolator(args);
            return messageTemplate; // todo variable substitution
        }
        // if template not found return empty string
        return '';
    }
}

// taken from angular translate
function getFirstBrowserLanguage() {
    let nav = window.navigator,
    browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
    language;

    // support for HTML 5.1 "navigator.languages"
    if (Array.isArray(nav.languages)) {
        for (let i = 0; i < nav.languages.length; i++) {
            language = nav.languages[i];
            if (language && language.length) {
                return language;
            }
        }
    }

    // support for other well known properties in browsers
    for (let i = 0; i < browserLanguagePropertyKeys.length; i++) {
        language = nav[browserLanguagePropertyKeys[i]];
        if (language && language.length) {
            return language;
        }
    }

    return null;
}
